/* New product gallery behaviour. */

if (!customElements.get('product-gallery-video')) {
  customElements.define(
    'product-gallery-video',
    class ProductGalleryVideo extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector('video');
        this.template = this.querySelector('template');
        this.iframe = null;
        this.isPlaying = false;
      }

      connectedCallback() {
        if (!this.video && !this.template) return;

        if (this.video) this.video.muted = true;

        this.supportsHover = window.matchMedia('(hover: hover)').matches;

        if (this.supportsHover) {
          this.addEventListener('mouseenter', this.play.bind(this));
          this.addEventListener('mouseleave', this.pause.bind(this));
        } else {
          this.addEventListener('click', this.toggle.bind(this));
        }
      }

      disconnectedCallback() {
        this.pause();
      }

      toggle() {
        if (this.isPlaying) {
          this.pause();
        } else {
          this.play();
        }
      }

      play() {
        if (this.isPlaying) return;
        this.isPlaying = true;
        this.classList.add('is-playing');

        if (this.video) {
          const playPromise = this.video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              this.isPlaying = false;
              this.classList.remove('is-playing');
            });
          }
          return;
        }

        if (this.template && !this.iframe) {
          this.iframe = this.template.content.firstElementChild.cloneNode(true);
          this.appendChild(this.iframe);
        }
      }

      pause() {
        if (!this.isPlaying) return;
        this.isPlaying = false;
        this.classList.remove('is-playing');

        if (this.video) {
          this.video.pause();
          this.video.currentTime = 0;
          return;
        }

        if (this.iframe) {
          this.iframe.remove();
          this.iframe = null;
        }
      }
    }
  );
}
